import { render, staticRenderFns } from "./CellText.vue?vue&type=template&id=a4e1595c&scoped=true"
import script from "./CellText.vue?vue&type=script&lang=js"
export * from "./CellText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e1595c",
  null
  
)

export default component.exports